import React, { useState, useMemo, useEffect, useRef } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import globalConfig from '../../configs/globalConfigs';
import AppBar from '@mui/material/AppBar';
import SwipeableViews from 'react-swipeable-views';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { Stomp } from '@stomp/stompjs';

import Close from '@material-ui/icons/Close'
import { Snackbar } from '@material-ui/core';
import { Menu } from '@mui/material';

import Cookies from 'js-cookie';
import { MenuItem, Select, InputLabel, FormControl, IconButton } from '@mui/material';
import {
    FormLabel,
    RadioGroup,
    Radio,
} from '@material-ui/core';

import { useHistory } from "react-router-dom";
import moment from 'moment';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Box } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';

import Checkbox from '@material-ui/core/Checkbox';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Collapse from '@material-ui/core/Collapse';
import Paper from '@material-ui/core/Paper';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Skeleton from '@material-ui/lab/Skeleton';
import {
    GoogleMap,
    Marker,
    LoadScript,
    OverlayView,
    DirectionsRenderer,
} from "@react-google-maps/api";

import {
    MaterialReactTable
} from 'material-react-table';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';
import BuildIcon from '@mui/icons-material/Build';
import Switch from '@mui/material/Switch';
import SettingsIcon from '@mui/icons-material/Settings';
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/Power'; // (não usado aqui, mas mantive)

import api from '../../services/api';

import "./MapPage.css";

import switch_off from '../../assets/imgs/switch-off.png';
import switch_on from '../../assets/imgs/switch-on.png';

import mini_icone_carro from '../../assets/imgs/mini_icone_carro.png';
import mini_icone_moto from '../../assets/imgs/mini_icone_moto.png';

import icone_origem from '../../assets/imgs/icone_origem.png';
import icone_destino from '../../assets/imgs/icone_destino.png';
import icone_parada from '../../assets/imgs/icone_parada.png';

import icone_pgm from '../../assets/imgs/icone_pgm.png';
import icone_medidor from '../../assets/imgs/icone_medidor.png';
import icone_subestacao from '../../assets/imgs/icone_subestacao.png';
import icone_casa from '../../assets/imgs/icone_casa.png';
import icone_loja from '../../assets/imgs/icone_loja.png';

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        height: '1000px',
        backgroundColor: 'white',
    },
    toolbar: {},
    toolbarIcon: {},
    appBar: {},
    appBarShift: {},
    menuButton: {},
    menuButtonHidden: {},
    title: { flexGrow: 1 },
    drawerPaper: {},
    drawerPaperClose: {},
    appBarSpacer: theme.mixins.toolbar,
    content: {
        flexGrow: 1,
        display: 'flex',
    },
    container: {
        display: 'flex',
        height: '1000px',
        backgroundColor: 'green',
    },
    paper: {},
    fixedHeight: {},
}));

const libraries = ["places"];

export default function MapaOSComponent() {
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarSeverity, setSnackbarSeverity] = useState("success");
    const handleCloseSnackbar = () => setSnackbarOpen(false);

    const classes = useStyles();
    const history = useHistory();

    const [agendamentos, setAgendamentos] = useState([]);
    const [showTable, setShowTable] = useState(true);
    const [map, setMap] = useState();
    const mapRef = useRef(null);

    const [lat, setLat] = useState();
    const [lng, setLng] = useState();
    const [mapPosition, setMapPosition] = useState({ lat: lat, lng: lng });
    const [zoom, setZoom] = useState(5);

    const [endereco, setEndereco] = useState();
    const [configuracoes, setConfiguracoes] = useState();
    const [loadingAgendamentos, setLoadingAgendamentos] = useState();
    const [directions, setDirections] = useState([]); // array de { result, color }

    const containerStyle = { width: "100%", height: "100%" };

    const options = {
        mapTypeId: "roadmap",
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: true,
        maxZoom: 21,
        styles: [
            { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", stylers: [{ visibility: "off" }] },
            { featureType: "administrative.land_parcel", stylers: [{ visibility: "off" }] },
            { featureType: "administrative.neighborhood", stylers: [{ visibility: "off" }] },
        ],
    };

    const hasBase = typeof lat === "number" && typeof lng === "number";
    const baseMarker = hasBase ? [{ position: { lat, lng }, title: "Unidade Base" }] : [];

    // ------------ UTIL: datas ------------
    function toDate(arr) {
        if (!arr || arr.length < 5) return new Date(); // fallback
        return new Date(arr[0], arr[1] - 1, arr[2], arr[3], arr[4]); // mês 0-based
    }

    // ------------ Agrupar + ordenar + numerar ------------
    function prepararAgendamentos(lista) {
        if (!lista || !Array.isArray(lista)) return [];
        const grupos = {};
        lista.forEach((ag) => {
            const key = `${ag.idequipe}_${ag.idveiculo}`;
            if (!grupos[key]) grupos[key] = [];
            grupos[key].push(ag);
        });

        const resultado = [];
        Object.keys(grupos).forEach((key, grupoIndex) => {
            const ordenada = grupos[key].slice().sort(
                (a, b) => toDate(a.datainicioagendamento) - toDate(b.datainicioagendamento)
            );
            ordenada.forEach((item, idx) => {
                resultado.push({ ...item, sequencia: idx + 1, grupoIndex });
            });
        });
        return resultado;
    }

    // ------------ Cores de rotas (grupo constante, variação por par) ------------
    function gerarCores(grupoIndex, rotaIndex) {
        const coresBase = ["#1E90FF", "#FF4500", "#32CD32", "#FFD700", "#8A2BE2", "#FF1493"];
        const base = coresBase[grupoIndex % coresBase.length];
        // mesma cor base; alterna transparência para pares subsequentes
        return rotaIndex % 2 === 1 ? `${base}AA` : base;
    }

    // ------------ API ------------
    async function listarInformacoes() {
        try {
            const token = Cookies.get("token");
            const headers = { Authorization: "Bearer " + token };

            const respCfg = await api.get("/v1/protected/configuracoes", { headers });
            setConfiguracoes(respCfg.data);

            const lati = parseFloat(respCfg.data.unidade_base.latitude);
            const lngi = parseFloat(respCfg.data.unidade_base.longitude);
            setLat(lati); setLng(lngi);
            setMapPosition({ lat: lati, lng: lngi });

            const { logradouro, numero, bairro, cidade, estado, cep } = respCfg.data.unidade_base;
            setEndereco(`${logradouro}, ${numero}, ${bairro}, ${cidade}, ${estado} - ${cep}`);

            const respAg = await api.get("/v1/protected/ordemservico/listaragendamentosparamapa", { headers });
            // PREPARA (agrupar + ordenar + sequenciar)
            const processados = prepararAgendamentos(respAg.data);
            setAgendamentos(processados);
            setLoadingAgendamentos(false);
        } catch (err) {
            console.log("Erro ao listar informações: ", err);
            setLoadingAgendamentos(false);
        }
    }

    useEffect(() => { listarInformacoes(); }, []);

    // ------------ Montar rotas por grupo (pares consecutivos) ------------
    useEffect(() => {
        if (!map || !agendamentos || agendamentos.length === 0) {
            setDirections([]);
            return;
        }

        // Reconstroi grupos a partir dos agendamentos já sequenciados
        const grupos = {};
        agendamentos.forEach((ag) => {
            const key = `${ag.idequipe}_${ag.idveiculo}`;
            if (!grupos[key]) grupos[key] = [];
            grupos[key].push(ag);
        });

        const directionsPromises = [];

        Object.keys(grupos).forEach((key, grupoIndex) => {
            // Garante ordem por data (crescente: menor → maior)
            const lista = grupos[key].slice().sort(
                (a, b) => toDate(a.datainicioagendamento) - toDate(b.datainicioagendamento)
            );
            for (let i = 0; i < lista.length - 1; i++) {
                const origin = { lat: parseFloat(lista[i].latitude), lng: parseFloat(lista[i].longitude) };
                const destination = { lat: parseFloat(lista[i + 1].latitude), lng: parseFloat(lista[i + 1].longitude) };

                const directionsService = new window.google.maps.DirectionsService();
                directionsPromises.push(
                    new Promise((resolve) => {
                        directionsService.route(
                            { origin, destination, travelMode: window.google.maps.TravelMode.DRIVING },
                            (result, status) => {
                                if (status === window.google.maps.DirectionsStatus.OK) {
                                    resolve({ result, color: gerarCores(grupoIndex, i) });
                                } else {
                                    console.error("Erro rota", status);
                                    resolve(null);
                                }
                            }
                        );
                    })
                );
            }
        });

        Promise.all(directionsPromises).then((res) => {
            setDirections(res.filter(Boolean));
        });
    }, [map, agendamentos]);

    // ------------ Ícone instalação ------------
    function processarIconeInstalacao(tipo) {
        if (tipo === 0) return icone_casa;
        if (tipo === 1) return icone_loja;
        if (tipo === 2) return icone_subestacao;
        return icone_casa;
    }

    // ------------ Marcador custom (número grande ao lado do ícone) ------------
    const LocalComponent = ({ lat, lng, onClick, tipo_icone, agendamento }) => {
        const formatDateBR = (arr) => {
            if (!arr || !Array.isArray(arr)) return "-";
            const [year, month, day, hour, minute] = arr;
            if ([year, month, day, hour, minute].some(v => v === undefined)) return "-";
            const d = new Date(year, month - 1, day, hour, minute);
            const dd = String(d.getDate()).padStart(2, "0");
            const mm = String(d.getMonth() + 1).padStart(2, "0");
            const yyyy = d.getFullYear();
            const hh = String(d.getHours()).padStart(2, "0");
            const min = String(d.getMinutes()).padStart(2, "0");
            return `${dd}/${mm}/${yyyy} ${hh}:${min}`;
        };

        const names = [
            agendamento?.nomemapa?.trim(),
            agendamento?.nomeempresarial?.trim(),
            agendamento?.nomefantasia?.trim(),
        ].filter(Boolean);

        return (
            <OverlayView
                position={{ lat, lng }}
                mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
                getPixelPositionOffset={(width, height) => ({ x: -(width / 2), y: -(height / 2) })}
            >
                <div
                    onClick={(event) => { event.stopPropagation(); onClick(lat, lng); }}
                    style={{
                        position: "absolute",
                        top: 0, left: 0,
                        transform: "translate(-50%, -50%)",
                        cursor: "pointer",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        minWidth: "520px",
                    }}
                >
                    {/* número grande + ícone lado a lado */}
                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <div
                            style={{
                                fontSize: "28px",
                                fontWeight: "800",
                                color: "#E53935",
                                lineHeight: 1,
                            }}
                            title={`Sequência #${agendamento.sequencia}`}
                        >
                            #{agendamento.sequencia}
                        </div>
                        <img
                            alt="icone"
                            style={{ width: "44px", height: "44px" }}
                            src={processarIconeInstalacao(tipo_icone)}
                        />
                    </div>

                    {/* tooltip */}
                    <div
                        style={{
                            backgroundColor: "rgba(0,0,0,0.75)",
                            color: "white",
                            fontSize: "12px",
                            textAlign: "left",
                            borderRadius: "6px",
                            padding: "8px 10px",
                            marginTop: "6px",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                            whiteSpace: "pre-wrap",
                        }}
                    >
                        {/* Sempre mostrar */}
                        {names.map((name, index) => (
                            <div key={index}>{name}</div>
                        ))}
                        <div>📌 Sigma: {agendamento?.sigma ?? "-"}</div>
                        <div>📅 ID Agendamento: {agendamento?.idagendamento ?? "-"}</div>

                        {/* Mostrar somente se zoom > 10 */}
                        {zoom > 10 && (
                            <>
                                <div>📝 OS: {agendamento?.os ?? "-"}</div>
                                <div>💬 Solicitação: {agendamento?.descricaosolicitacao ?? "-"}</div>
                                <div>👥 Equipe: {agendamento?.nomeequipe ?? "-"}</div>
                                <div>🚗 Veículo: {agendamento?.placaveiculo ?? "-"}</div>
                                <div>🕒 Início: {formatDateBR(agendamento?.datainicioagendamento)}</div>
                                <div>🕔 Fim: {formatDateBR(agendamento?.datafimagendamento)}</div>
                            </>
                        )}
                    </div>

                </div>
            </OverlayView>
        );
    };

    const columnsAgendamentos = useMemo(
        () => [
            { accessorKey: "nomemapa", header: "Local", size: 150, maxHeight: 60 },
            { accessorKey: "sigma", header: "ID Integrador", size: 100, maxHeight: 60 },
            { accessorFn: (row) => row.sequencia, header: "Seq.", size: 60 },
            { accessorKey: "nomeequipe", header: "Equipe", size: 140 },
            { accessorKey: "placaveiculo", header: "Veículo", size: 120 },
        ],
        []
    );

    return (
        <div>
            {loadingAgendamentos ? (
                <Skeleton animation={"wave"} style={{ backgroundColor: "#48D1CC" }} />
            ) : (
                <div className={classes.content}>
                    <React.Fragment>
                        <Grid container direction="row" alignItems="center" item xs={12}>
                            <Grid
                                container
                                direction="row"
                                justifyContent="center"
                                align="center"
                                item
                                xs={12}
                                style={{ position: "absolute", top: 5, left: 0, width: "100%", height: "100%", zIndex: 0 }}
                            >
                                <LoadScript
                                    googleMapsApiKey={globalConfig.mapKey}
                                    libraries={libraries}
                                    loadingElement={<div>Loading...</div>}
                                >
                                    <GoogleMap
                                        center={mapPosition}
                                        zoom={zoom}
                                        onLoad={(mapInstance) => setMap(mapInstance)}
                                        mapContainerStyle={containerStyle}
                                        options={options}
                                        
                                    >
                                        {/* Base marker (só se tiver lat/lng válidos) */}
                                        {hasBase && (
                                            <Marker
                                                key={baseMarker[0].title}
                                                position={baseMarker[0].position}
                                                title={baseMarker[0].title}
                                            />
                                        )}

                                        {/* Marcadores custom por agendamento */}
                                        {agendamentos && agendamentos.map((agendamento) => {
                                            const latag = parseFloat(agendamento.latitude);
                                            const lngag = parseFloat(agendamento.longitude);
                                            const valido = !isNaN(latag) && !isNaN(lngag);
                                            if (!valido) return null;

                                            return (
                                                <React.Fragment key={`${agendamento.idinstalacao}_${agendamento.idagendamento}`}>
                                                    <LocalComponent
                                                        lat={latag}
                                                        lng={lngag}
                                                        onClick={() => {
                                                            setZoom(18);
                                                            setMapPosition({ lat: latag, lng: lngag });
                                                        }}
                                                        tipo_icone={agendamento.iconemapa}
                                                        agendamento={agendamento}
                                                    />
                                                </React.Fragment>
                                            );
                                        })}

                                        {/* Rotas */}
                                        {directions && directions.map((d, idx) => (
                                            <DirectionsRenderer
                                                key={idx}
                                                directions={d.result}
                                                options={{
                                                    suppressMarkers: true,
                                                    polylineOptions: { strokeColor: d.color, strokeWeight: 4 },
                                                }}
                                            />
                                        ))}
                                    </GoogleMap>
                                </LoadScript>
                            </Grid>
                        </Grid>
                    </React.Fragment>
                </div>
            )}

            <Drawer
                variant="permanent"
                anchor="left"
                sx={{
                    top: "100px",
                    height: "calc(100vh - 100px)",
                    "& .MuiDrawer-paper": {
                        position: "fixed",
                        top: "100px",
                        width: "300px",
                    },
                }}
            >
                <List>
                    <ListItem button onClick={() => setShowTable(!showTable)}>
                        <ListItemIcon><DashboardIcon /></ListItemIcon>
                        <ListItemText primary="Instalações" />
                    </ListItem>

                    {showTable && (
                        <Box sx={{ width: "100%", padding: "16px" }}>
                            <MaterialReactTable
                                columns={columnsAgendamentos}
                                data={agendamentos}
                                enableGlobalFilterModes
                                enableTopToolbar
                                enableBottomToolbar={false}
                                enablePagination={false}
                                enableColumnFilters
                                enableColumnActions={false}
                                enableSorting={false}
                                enableRowSelection={false}
                                paginationDisplayMode={"pages"}
                                getRowId={(row) => `${row.idinstalacao}_${row.idagendamento}`}
                                initialState={{
                                    pagination: { pageSize: 1000, pageIndex: 0 },
                                    showGlobalFilter: true,
                                }}
                                muiTableBodyRowProps={({ row }) => ({
                                    sx: { height: 40, color: 'black', cursor: 'pointer' },
                                    onClick: () => {
                                        const ag = row.original;
                                        const latag = parseFloat(ag.latitude);
                                        const lngag = parseFloat(ag.longitude);
                                        if (!isNaN(latag) && !isNaN(lngag)) {
                                            setZoom(18);
                                            setMapPosition({ lat: latag, lng: lngag });
                                        }
                                    },
                                })}
                                muiTableContainerProps={{ sx: { maxHeight: "1000px", color: 'black' } }}
                                enableColumnFilterModes={false}
                                enableExpandAll
                                enableColumnPinning
                                enableColumnResizing
                                muiPaginationProps={{ rowsPerPageOptions: [20, 50, 100], variant: "outlined" }}
                                enableFullScreenToggle
                                muiTablePaperProps={({ table }) => ({
                                    style: { zIndex: table.getState().isFullScreen ? 1000 : undefined, color: 'black' },
                                })}
                            />
                        </Box>
                    )}
                </List>
            </Drawer>

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={4000}
                onClose={handleCloseSnackbar}
                message={snackbarMessage}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                ContentProps={{
                    'aria-describedby': 'message-id',
                    style: {
                        backgroundColor: snackbarSeverity === 'success' ? '#4caf50' : '#f44336',
                        marginTop: '60px',
                        fontSize: '16px',
                        fontWeight: 'bold',
                        border: '1px solid black',
                        borderRadius: '4px',
                        padding: '10px',
                        zIndex: 555,
                        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
                    }
                }}
            />
        </div>
    );
}
